module.exports = __webpack_public_path__ + "img/mask-makers-logo.c4dd0e1f.svg";